import AxiosService from 'plugins/TS-lib-utils-public/services/AxiosService';

class BillingService extends AxiosService {
    constructor() {
        super('management');
    }

    // practiceName opcional. Filtra por practica.
    getBilling = async (days, practiceName = null) => {
        try {
            let q = `/billing/statistics/?days=${days}`;
            if (practiceName) q += `&practiceName=${encodeURIComponent(practiceName)}`;
            return await this.get(q, {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                }
            });
        } catch (error) {
            return {
                status: error.response.status,
                statusText: error.response.statusText,
            };
        }
    };

    getBillingByPractice = async (days) => {
        try {
            return await this.get(`/billing/statisticsbypractice/?days=${days}`, {
                headers: {
                    Authorization: `Bearer ${this.getToken()}`,
                }
            });
        } catch (error) {
            return {
                status: error.response.status,
                statusText: error.response.statusText,
            };
        }
    };
}

export default new BillingService();
